const FETCH_USER_DATA = "auth/fetch-user-data";
const FETCH_USER_DATA_FAILED = "auth/fetch-user-data-failed";
const FETCH_USER_DATA_SUCCESS = "auth/fetch-user-data-success";
const UPDATE_USER_DATA = "auth/update-user-data";
const UPDATE_USER_DATA_FAILED = "auth/update-user-data-failed";
const UPDATE_USER_DATA_SUCCESS = "auth/update-user-data-success";
const fetchUserData = () => ({
  type: FETCH_USER_DATA
});
const fetchUserDataFailed = (error) => ({
  type: FETCH_USER_DATA_FAILED,
  error
});
const fetchUserDataSuccess = (payload) => ({
  type: FETCH_USER_DATA_SUCCESS,
  payload
});
const updateUserData = (payload) => ({
  type: UPDATE_USER_DATA,
  payload
});
const updateUserDataFailed = (payload) => ({
  type: UPDATE_USER_DATA_FAILED,
  payload
});
const updateUserDataSuccess = (payload) => ({
  type: UPDATE_USER_DATA_SUCCESS,
  payload
});
export {
  FETCH_USER_DATA,
  FETCH_USER_DATA_FAILED,
  FETCH_USER_DATA_SUCCESS,
  UPDATE_USER_DATA,
  UPDATE_USER_DATA_FAILED,
  UPDATE_USER_DATA_SUCCESS,
  fetchUserData,
  fetchUserDataFailed,
  fetchUserDataSuccess,
  updateUserData,
  updateUserDataFailed,
  updateUserDataSuccess
};
//# sourceMappingURL=actions.js.map
